import React from 'react';

import { BaseIconProps } from '.';

export const MagnifyingGlass = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="M428.4,139.8c164.6,0,296.3,131.7,296.3,296.3S593,732.4,428.4,732.4S132.1,600.7,132.1,436.1
    S263.8,139.8,428.4,139.8z M428.4-0.1C198-0.1,0.4,197.4,0.4,436.1s197.5,428,428,428c90.5,0,181.1-32.9,255.2-82.3l279.8,279.8
    c24.7,24.7,65.8,24.7,98.8,0c24.7-24.7,24.7-65.8,0-98.8L782.3,691.2c57.6-74.1,82.3-164.6,82.3-255.2
    C864.6,197.4,667.1-0.1,428.4-0.1z"
  />
);
